'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.requireFeatureSaga = requireFeatureSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(requireFeatureSaga);

function requireFeatureSaga(client, replaceState, name, to) {
  var enabled;
  return _regenerator2.default.wrap(function requireFeatureSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.featureById, [client, name]);

        case 2:
          enabled = _context.sent;

          if (enabled) {
            _context.next = 7;
            break;
          }

          _context.next = 6;
          return (0, _effects.call)(replaceState, to);

        case 6:
          return _context.abrupt('return', _context.sent);

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = function (store, client, name) {
  var to = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  return function (nextState, replaceState, cb) {
    return store.runSagaOnce(requireFeatureSaga, client, replaceState, name, to).done.then(function () {
      return cb();
    });
  };
};